import { cloneDeep } from 'lodash'

export const trackCompanyProgress = (staticData: any, dynamicData: any) => {
  if (!dynamicData) {
    return staticData
  }
  const newData = cloneDeep(staticData)
  newData.forEach((item: any) => {
    item.active = dynamicData?.[item.group]?.[item.key]
  })
  return newData
}
